export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE ?? '/api',
  siteUrl: import.meta.env.VITE_SITE_URL ?? '',
  legacyContactFormUrl: import.meta.env.VITE_LEGACY_CONTACT_FORM_URL ?? '',
  legacyCareerFormUrl: import.meta.env.VITE_LEGACY_CAREER_FORM_URL ?? '',
};

export const isServerBackendEnabled = env.apiBaseUrl.trim().toLowerCase() !== 'local';
